// extracted by mini-css-extract-plugin
export default {"SuccessManagerOptionsIcon":"styles_SuccessManagerOptionsIcon__p-Spf"};